import Settings from 'components/shopifySettings';

const SettingsPage = () => {
  return <Settings />;
};

export default SettingsPage;
